import { c as _c } from "react/compiler-runtime";
export function AmericanExpressIcon(t0) {
  const $ = _c(12);
  const {
    decorative
  } = t0;
  const t1 = decorative ? undefined : "img";
  const t2 = decorative ? undefined : "American Express";
  const t3 = decorative || undefined;
  let t10;
  let t11;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path fill="#000" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3Z" opacity=".07" />;
    t5 = <path fill="#006FCF" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32Z" />;
    t6 = <path fill="#FFF" d="M22.012 19.936v-8.421L37 11.528v2.326l-1.732 1.852L37 17.573v2.375h-2.766l-1.47-1.622-1.46 1.628-9.292-.02Z" />;
    t7 = <path fill="#006FCF" d="M23.013 19.012v-6.57h5.572v1.513h-3.768v1.028h3.678v1.488h-3.678v1.01h3.768v1.531h-5.572Z" />;
    t8 = <path fill="#006FCF" d="m28.557 19.012 3.083-3.289-3.083-3.282h2.386l1.884 2.083 1.89-2.082H37v.051l-3.017 3.23L37 18.92v.093h-2.307l-1.917-2.103-1.898 2.104h-2.321Z" />;
    t9 = <path fill="#FFF" d="M22.71 4.04h3.614l1.269 2.881V4.04h4.46l.77 2.159.771-2.159H37v8.421H19l3.71-8.421Z" />;
    t10 = <path fill="#006FCF" d="m23.395 4.955-2.916 6.566h2l.55-1.315h2.98l.55 1.315h2.05l-2.904-6.566h-2.31Zm.25 3.777.875-2.09.873 2.09h-1.748Z" />;
    t11 = <path fill="#006FCF" d="M28.581 11.52V4.953l2.811.01L32.84 9l1.456-4.046H37v6.565l-1.74.016v-4.51l-1.644 4.494h-1.59L30.35 7.01v4.51h-1.768Z" />;
    $[0] = t10;
    $[1] = t11;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t10 = $[0];
    t11 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
    t8 = $[6];
    t9 = $[7];
  }
  let t12;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t12 = <svg className="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24" width="38" height="24" role={t1} aria-label={t2} aria-hidden={t3}>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</svg>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  return t12;
}